"use strict";
var $ = require('jquery');
var Analytics = (function () {
    function Analytics(options) {
        var $window = $(window);
        var self = this;
        this.setOptions(options);
        options = this.getOptions();
        $('body').on('click', 'a', function () {
            var href = $(this).attr('href');
            if (typeof (href) !== "undefined" && href !== null) {
                var category = self.determineLinkEventCategory(href);
                var nonInteract = category === 'Outbound Link' ? true : false;
                if (typeof (category) !== "undefined" && category !== null) {
                    self.trackEvent(category, "Click", href, undefined, nonInteract);
                }
            }
        });
        $("form")
            .filter("[action^='http://'], [action^='https://']")
            .filter(":not([action*='://" + window.location.hostname + "'])")
            .submit(function () {
            self.trackEvent("Outbound Form Submissions", "Submit", $(this).attr("action"));
        });
        if (options.viewedBottom.enable) {
            var hasHitBottom_1 = false;
            var $contentArea_1;
            if (typeof options.$contentArea !== 'undefined') {
                $contentArea_1 = $(options.$contentArea);
            }
            else {
                $contentArea_1 = $(options.contentArea);
            }
            var scrollingHitsBottomTest = function (event) {
                if (!hasHitBottom_1) {
                    if (self.isInView($contentArea_1)) {
                        $window.unbind(event);
                        hasHitBottom_1 = true;
                        self.trackEvent("Viewed", "Window Scroll: Viewed Bottom", window.location.href, undefined, options.viewedBottom.noninteraction);
                    }
                }
            };
            $window.bind('scroll', scrollingHitsBottomTest);
            var windowHeight = $window.height();
            var contentHeight = $contentArea_1.height();
            if (contentHeight <= windowHeight) {
                self.trackEvent("Viewed", "Document Ready: Viewed Bottom", window.location.href, undefined, options.viewedBottom.noninteraction);
            }
        }
    }
    Analytics.prototype.trackPage = function (pageURL) {
        if (pageURL.substring(0, 1) !== '/') {
            pageURL = '/' + pageURL;
        }
        if (this.isClassicPageTrackerLoaded()) {
            _gaq.push(["_trackPageview", pageURL]);
        }
        else if (this.isUniversalPageTrackerLoaded()) {
            ga('send', 'pageview');
        }
        else {
            global.console.log("Google Analytics not loaded. Trying to track page: " + pageURL);
        }
    };
    Analytics.prototype.trackEvent = function (category, action, opt_label, opt_value, opt_noninteraction) {
        if (typeof opt_label !== 'undefined') {
            opt_label = opt_label.toString();
        }
        if (typeof opt_value !== "undefined" && typeof opt_value !== "number") {
            global.console.error("Value provided for opt_value needs to be a number. opt_value: " + opt_value);
        }
        if (this.isClassicPageTrackerLoaded()) {
            _gaq.push(["_trackEvent", category, action, opt_label, opt_value, opt_noninteraction]);
        }
        else if (this.isUniversalPageTrackerLoaded()) {
            ga('send', 'event', category, action, opt_label, opt_value, { 'nonInteraction': opt_noninteraction });
        }
        else {
            global.console.log("Google Analytics not loaded. Trying to tracked parameters: ", {
                category: category,
                action: action,
                opt_label: opt_label,
                opt_value: opt_value,
                opt_noninteraction: opt_noninteraction
            });
        }
    };
    Analytics.prototype.setOptions = function (options) {
        this.options = options || {};
        if (typeof this.options.contentArea === "undefined") {
            this.options.contentArea = 'body';
        }
        if (typeof this.options.viewedBottom === "undefined") {
            this.options.viewedBottom = {};
        }
        if (typeof this.options.viewedBottom.enable === "undefined") {
            this.options.viewedBottom.enable = false;
        }
        if (typeof this.options.viewedBottom.noninteraction === "undefined") {
            this.options.viewedBottom.noninteraction = true;
        }
        if (typeof this.options.hostnames === "undefined") {
            this.options.hostnames = new Array();
        }
        this.options.hostnames.push(window.location.hostname);
        if (window.location.hostname.toLowerCase().indexOf("www.") === 0) {
            this.options.hostnames.push(window.location.hostname.substring(4));
        }
        else {
            this.options.hostnames.push("www." + window.location.hostname);
        }
    };
    Analytics.prototype.getOptions = function () {
        return this.options;
    };
    Analytics.prototype.determineLinkEventCategory = function (href) {
        var category = null;
        var options = this.getOptions();
        if (typeof (href) !== "undefined" && href !== null) {
            href = href.toLowerCase();
            var urlParts = href.match(/^((.*:)?\/\/([^\/:]+@)?([^\/:]+)(:[^\/]+)?)?([^\?]*)(\?.+)??$/);
            var isOutbound = void 0;
            var hrefhostname = void 0;
            var hrefPath = void 0;
            if (urlParts !== undefined && urlParts !== null) {
                hrefhostname = urlParts[4];
                hrefPath = urlParts[6];
                if (typeof hrefPath === "undefined") {
                    hrefPath = "";
                }
                if (typeof hrefhostname === "undefined") {
                    hrefhostname = "";
                }
                if (hrefhostname === "" || $.inArray(hrefhostname, options.hostnames) > -1) {
                    isOutbound = false;
                }
                else {
                    isOutbound = true;
                }
            }
            else {
                isOutbound = false;
                hrefPath = href;
            }
            if (isOutbound) {
                category = "Outbound Link";
            }
            else if (href.indexOf("mailto:") === 0) {
                category = "Email Link";
            }
            else if (href.indexOf("tel:") === 0) {
                category = "Telephone Link";
            }
            else if (hrefPath.length > 0 && hrefPath.charAt(href.length - 1) !== '/') {
                var extIndexOf = hrefPath.lastIndexOf('.');
                if (extIndexOf !== -1) {
                    var ext = hrefPath.substring(extIndexOf + 1);
                    if (ext !== "html" && ext !== "htm" && !(new RegExp('#')).test(ext)) {
                        category = "Download Link";
                    }
                }
            }
        }
        return category;
    };
    Analytics.prototype.isClassicPageTrackerLoaded = function () {
        return typeof (_gaq) !== "undefined" && _gaq !== null;
    };
    Analytics.prototype.isUniversalPageTrackerLoaded = function () {
        return typeof (ga) !== "undefined" && ga !== null;
    };
    Analytics.prototype.isInView = function (elem) {
        var $window = $(window);
        var $elem = $(elem);
        var docViewBottom = $window.scrollTop() + $window.height();
        var elemBottom = $elem.offset().top + $elem.height();
        return (elemBottom <= docViewBottom);
    };
    return Analytics;
}());
exports.Analytics = Analytics;
;
